import type {
  LoginResponse,
  SessionContext,
  TokenResponse,
} from '@mervonn/shared-types';
import { apiRequest } from '../../lib/api/client';

export const authApi = {
  login: (email: string, password: string) =>
    apiRequest<LoginResponse>('/auth/login', {
      method: 'POST',
      body: { email, password },
      anonymous: true,
    }),

  verifyMfa: (mfaChallengeToken: string, code: string) =>
    apiRequest<TokenResponse>('/auth/mfa/verify', {
      method: 'POST',
      body: { mfa_challenge_token: mfaChallengeToken, code },
      anonymous: true,
    }),

  /** GET /auth/me — identity + effective permissions (ADR-13A-001). */
  sessionContext: (signal?: AbortSignal) =>
    apiRequest<SessionContext>('/auth/me', { signal }),

  logout: () => apiRequest<{ status: string }>('/auth/logout', { method: 'POST' }),

  /** FR-ACC-003 — always `{ status: 'ok' }` whether or not the email
   * exists (enumeration-resistant; `password-reset.service.ts`). */
  requestPasswordReset: (email: string) =>
    apiRequest<{ status: string }>('/auth/password/reset-request', {
      method: 'POST',
      body: { email },
      anonymous: true,
    }),

  /** Re-design T22 — accept an invitation: the one-time link's token + the password the user chooses (FR-ACC-002). */
  acceptInvitation: (token: string, newPassword: string) =>
    apiRequest<{ status: string }>(`/invitations/${encodeURIComponent(token)}/accept`, {
      method: 'POST',
      body: { new_password: newPassword },
      anonymous: true,
    }),

  /** FR-ACC-004 — single-use token from the emailed reset link. */
  completePasswordReset: (token: string, newPassword: string) =>
    apiRequest<{ status: string }>('/auth/password/reset', {
      method: 'POST',
      body: { token, new_password: newPassword },
      anonymous: true,
    }),
};
